// extracted by mini-css-extract-plugin
export default {"GlobalAudioWrapper":"GlobalAudio_GlobalAudioWrapper__7OVXQ","AudioToggle":"GlobalAudio_AudioToggle__emKZw"};